// extracted by mini-css-extract-plugin
export default {"dropzone":"folderUpload_dropzone__0kucO","browseButton":"folderUpload_browseButton__GvDZq"};